// Arabic solutions content. Slugs match English so hreflang pairs
// automatically ({en: /solutions/:slug, ar: /ar/solutions/:slug}).

export const SOLUTIONS_INDEX_INTRO_AR =
  "كل منصة أدناه سبق أن وضعناها في الإنتاج. البنية محسومة، الحالات الاستثنائية مكتشفة، والأخطاء المكلفة ارتُكبت بالفعل — على حسابنا. ما تدفعون ثمنه هو علامتكم التجارية، قواعد عملكم، والأجزاء الخاصة بكم فعليًا. لا يجب أن يُحاسَب أحد مرتين على نفس المشكلة.";

export const SOLUTIONS_AR = {
  "on-demand-delivery-platform": {
    slug: "on-demand-delivery-platform",
    navLabel: "منصة التوصيل عند الطلب",
    eyebrow: "الحلول",
    h1: "منصة التوصيل عند الطلب",
    meta: { title: "منصة التوصيل عند الطلب — وفا سوليوشنز", description: "أربعة تطبيقات على خلفية واحدة. مبنية في عُمان، جاهزة للإطلاق وقابلة للعلامة البيضاء." },
    intro: "أربعة تطبيقات على خلفية واحدة: تطبيق عملاء، تطبيق سائق، لوحة تحكم إدارية، وبوابة أعمال للشاحنين. حجز متعدد الخدمات، أربع طرق تسعير مع بطاقات أسعار مخصصة لكل عميل، توزيع آلي بعروض متتالية ومهلة زمنية، تتبع مباشر مع مخطط زمني للحالة، إثبات تسليم بثلاث خطوات، محرك عمولة السائقين، محفظة، إصدار بوليصة شحن بباركود وطباعة دفعية، واجهة برمجية عامة للطلبات، ووحدة حسابات مع تصدير إلى Excel — عربي وإنجليزي.",
    sections: [
      { type: "callout", text: "الحالة: جاهز للإطلاق في عُمان." },
      { type: "grid", heading: "ما داخل الحزمة", items: [
        { title: "تطبيق العملاء", desc: "حجز متعدد الخدمات، محفظة، تتبع مباشر، وتقييمات." },
        { title: "تطبيق السائق", desc: "عروض، GPS، وإثبات تسليم بثلاث خطوات (الاسم، الصورة، التوقيع)." },
        { title: "لوحة الإدارة", desc: "التوزيع، الوكلاء، بطاقات الأسعار، والحسابات." },
        { title: "بوابة الشاحنين", desc: "خدمة ذاتية B2B، بطاقات أسعار لكل عميل، وفواتير." },
        { title: "محرك التوزيع", desc: "عروض متتالية بمهل زمنية وتراجع يدوي." },
        { title: "واجهة برمجية للطلبات", desc: "لتدفع الأنظمة الشريكة الطلبات إلى المنصة." },
      ] },
    ],
    related: [
      { tag: "الحلول", label: "برمجيات اللوجستيات وإدارة الأسطول", to: "/ar/solutions/logistics-fleet-software" },
      { tag: "الحلول", label: "إدارة المستودعات", to: "/ar/solutions/warehouse-management" },
      { tag: "الأعمال", label: "منصة التوصيل والخدمات اللوجستية", to: "/ar/work/delivery-logistics-platform" },
    ],
  },
  "logistics-fleet-software": {
    slug: "logistics-fleet-software",
    navLabel: "برمجيات اللوجستيات وإدارة الأسطول",
    eyebrow: "الحلول",
    h1: "برمجيات اللوجستيات وإدارة الأسطول",
    meta: { title: "برمجيات اللوجستيات وإدارة الأسطول", description: "التوزيع، إدارة المسارات، تتبع الأسطول، بطاقات الأسعار، والفوترة." },
    intro: "التوزيع، إدارة المسارات، تتبع الأسطول، إدارة السائقين، بطاقات أسعار العملاء، الفوترة، والتقارير التشغيلية. يُنشر بشكل مستقل أو جنبًا إلى جنب مع نظام ERP الحالي لديكم.",
    sections: [
      { type: "grid", heading: "الوحدات", items: [
        { title: "التوزيع", desc: "آلي أو يدوي، لكل مجموعة سائقين." },
        { title: "المسارات", desc: "التسلسل، التحسين، وإعادة التخطيط الفوري." },
        { title: "تتبع الأسطول", desc: "GPS، المناطق الجغرافية، ومعدل الاستخدام." },
        { title: "السائقون", desc: "السجلات، المستندات، والعمولة." },
        { title: "بطاقات أسعار العملاء", desc: "لكل عقد، لكل خدمة، ولكل منطقة." },
        { title: "الفوترة", desc: "حسب العميل والفترة، مُصدَّرة إلى نظام حساباتكم." },
      ] },
    ],
    related: [
      { tag: "الحلول", label: "منصة التوصيل عند الطلب", to: "/ar/solutions/on-demand-delivery-platform" },
      { tag: "الخدمات", label: "ERP و HRMS", to: "/ar/services/erp-software-development-company-in-oman" },
      { tag: "الصناعات", label: "الخدمات اللوجستية والنقل", to: "/ar/industries/logistics-software-development-oman" },
    ],
  },
  "warehouse-management": {
    slug: "warehouse-management",
    navLabel: "إدارة المستودعات",
    eyebrow: "الحلول",
    h1: "نظام إدارة المستودعات",
    meta: { title: "إدارة المستودعات — وفا سوليوشنز", description: "من الاستلام إلى الإرسال، بدقة على مستوى الصندوق. تم التسليم لمشغّلين في سنغافورة وماليزيا والولايات المتحدة." },
    intro: "الاستلام، التخزين، إدارة المواقع والصناديق، الانتقاء، التعبئة، الإرسال، جرد المخزون، وسجل كامل للحركة — مع مسح الباركود على الهاتف الذي يحمله فريقكم بالفعل.",
    sections: [
      { type: "callout", text: "الحالة: تم بناؤه وتسليمه لمشغّلين في سنغافورة وماليزيا والولايات المتحدة." },
      { type: "grid", heading: "الوحدات", items: [
        { title: "الاستلام", desc: "الإشعار المسبق، الإيصالات، والتخزين." },
        { title: "المواقع", desc: "المناطق، الممرات، والصناديق." },
        { title: "الانتقاء والتعبئة", desc: "بالموجة، بالدفعة، ولطلب واحد." },
        { title: "الإرسال", desc: "قوائم الشحن، بوالص الشحن، والتسليم." },
        { title: "جرد المخزون", desc: "جرد دوري وجرد كامل." },
        { title: "سجل الحركة", desc: "كل يد ولمسة وطابع زمني." },
      ] },
    ],
    related: [
      { tag: "الحلول", label: "منصة التوصيل عند الطلب", to: "/ar/solutions/on-demand-delivery-platform" },
      { tag: "الحلول", label: "برمجيات اللوجستيات وإدارة الأسطول", to: "/ar/solutions/logistics-fleet-software" },
      { tag: "الأعمال", label: "نظام إدارة المستودعات", to: "/ar/work/warehouse-management-system" },
    ],
  },
  "e-commerce-marketplace": {
    slug: "e-commerce-marketplace",
    navLabel: "منصة السوق الإلكتروني",
    eyebrow: "الحلول",
    h1: "منصة السوق الإلكتروني متعددة البائعين",
    meta: { title: "منصة السوق الإلكتروني — وفا سوليوشنز", description: "تجارة متعددة البائعين مع تقسيم الطلبات، العمولات، والتحويلات. مبنية لعُمان ومنطقة الخليج." },
    intro: "تسجيل البائعين ولوحات تحكمهم، الكتالوج، محرك العمولة، تقسيم الطلبات بين البائعين، المدفوعات والتحويلات، التقييمات، وتكامل التوصيل.",
    sections: [
      { type: "callout", text: "الحالة: قيد التطوير للسوق العُماني ومنطقة الخليج." },
      { type: "grid", heading: "الوحدات", items: [
        { title: "البائعون", desc: "التسجيل، اعرف عميلك، ولوحات التحكم." },
        { title: "الكتالوج", desc: "الفئات، المتغيرات، والوسائط." },
        { title: "العمولات", desc: "لكل بائع، فئة، وحملة." },
        { title: "تقسيم الطلبات", desc: "سلة عميل واحدة، تنفيذات متعددة." },
        { title: "المدفوعات والتحويلات", desc: "التحصيل، الاحتفاظ، الإفراج، والاعتراضات." },
        { title: "التقييمات والتوصيل", desc: "حلقات تغذية راجعة وتسليم التوصيل." },
      ] },
    ],
    related: [
      { tag: "الصناعات", label: "التجزئة والتجارة الإلكترونية", to: "/ar/industries/ecommerce-software-development-oman" },
      { tag: "الحلول", label: "إدارة المستودعات", to: "/ar/solutions/warehouse-management" },
      { tag: "الحلول", label: "منصة التوصيل عند الطلب", to: "/ar/solutions/on-demand-delivery-platform" },
    ],
  },
  "showroom-management": {
    slug: "showroom-management",
    navLabel: "إدارة المعارض",
    eyebrow: "الحلول",
    h1: "نظام إدارة معارض السيارات",
    meta: { title: "إدارة المعارض — وفا سوليوشنز", description: "مخزون مملوك وبأمانة، المبيعات، العملاء المحتملون، الحجوزات، والمستندات. مباشر في مسقط." },
    intro: "مخزون مملوك وبأمانة، المبيعات، العملاء المحتملون، الحجوزات، المدفوعات والحسابات، إدارة المستندات، لوحات تحكم، تقارير، إشعارات، موقع عرض عام، وثلاثة نماذج قابلة للطباعة (تفويض بيع، إفراج فحص، وتجربة قيادة).",
    sections: [
      { type: "callout", text: "الحالة: مباشر في مسقط، ويُرخَّص لكل معرض." },
      { type: "grid", heading: "ما يشمله", items: [
        { title: "المخزون", desc: "المملوك والأمانة على شاشة واحدة." },
        { title: "المبيعات والعملاء المحتملون", desc: "من الاستفسار إلى البيع في مسار واحد." },
        { title: "الحجوزات", desc: "الاحتفاظ، العربون، وانتهاء الصلاحية." },
        { title: "المدفوعات والحسابات", desc: "نقدًا، بطاقة، تمويل، مصدَّرة إلى دفاتركم." },
        { title: "المستندات", desc: "التسجيل، التأمين، النقل، وسجل الخدمة." },
        { title: "موقع عرض عام", desc: "بحث للمستهلك، والاستفسارات تتدفق إلى العملاء المحتملين." },
        { title: "النماذج القابلة للطباعة", desc: "تفويض بيع، إفراج فحص، وتجربة قيادة." },
        { title: "لوحات وتقارير", desc: "حسب المندوب، الطراز، والشهر." },
      ] },
    ],
    related: [
      { tag: "الصناعات", label: "السيارات", to: "/ar/industries/automotive-software-development-oman" },
      { tag: "الخدمات", label: "تطوير CRM", to: "/ar/services/crm-software-development-company-in-oman" },
      { tag: "الأعمال", label: "منصة إدارة المعارض", to: "/ar/work/showroom-management-platform" },
    ],
  },
  "community-building-app": {
    slug: "community-building-app",
    navLabel: "تطبيق المجتمعات والمباني",
    eyebrow: "الحلول",
    h1: "تطبيق إدارة المجمعات السكنية",
    meta: { title: "تطبيق إدارة المجمعات السكنية — وفا سوليوشنز", description: "تطبيق للسكان للصيانة، الزوار، الإعلانات، والمدفوعات." },
    intro: "تطبيق للسكان لطلبات الصيانة، دخول الزوار والبوابات، الإعلانات، حجز المرافق، ودفع الرسوم، مع لوحة تحكم لإدارة العقار.",
    sections: [
      { type: "grid", heading: "ما يشمله", items: [
        { title: "طلبات الصيانة", desc: "صور، أولوية، وتتبع." },
        { title: "الزوار والبوابات", desc: "موافقات مسبقة، دخول برمز QR." },
        { title: "الإعلانات", desc: "على مستوى المبنى وحسب كل مجمع." },
        { title: "حجز المرافق", desc: "الجيم، القاعة، والمواقف." },
        { title: "دفع الرسوم", desc: "رسوم صيانة دورية ولمرة واحدة." },
        { title: "لوحة الإدارة", desc: "التذاكر، الإشغال، والذمم." },
      ] },
    ],
    related: [
      { tag: "الصناعات", label: "العقارات والمرافق", to: "/ar/industries/real-estate-software-development-oman" },
      { tag: "الخدمات", label: "تطوير تطبيقات الجوال", to: "/ar/services/mobile-app-development-company-in-oman" },
      { tag: "الخدمات", label: "تطوير CRM", to: "/ar/services/crm-software-development-company-in-oman" },
    ],
  },
  "shipploy": {
    slug: "shipploy",
    navLabel: "Shipploy — منصة النشر",
    eyebrow: "الحلول",
    h1: "Shipploy — انشروا من Git دون فريق عمليات تقنية",
    meta: { title: "Shipploy — منصة النشر | وفا سوليوشنز", description: "حوّلوا دفعات Git إلى تطبيقات حية. بيئات، نطاقات HTTPS، أسرار، وتراجع بضغطة واحدة، دون توظيف فريق عمليات." },
    intro: "معظم الفرق الصغيرة تخسر أسابيع في البنية التحتية قبل أن تُطلق أي شيء. يحوّل Shipploy عملية الدفع في Git إلى تطبيق يعمل — البناء، الحاوية، والتوجيه، كلها مُدارة تلقائيًا — ليقوم المطورون بالنشر دون تجهيز خوادم أو كتابة خطوط أنابيب.",
    sections: [
      { type: "callout", text: "الحالة: مباشر · الولايات المتحدة والهند." },
      { type: "grid", heading: "ما يقدّمه", items: [
        { title: "نشر مباشر من Git", desc: "اربطوا المستودع، ادفعوا، والبناء، الحاوية، والتوجيه تُدار تلقائيًا. لا ملفات خطوط أنابيب، لا إعداد خوادم." },
        { title: "بيئات منفصلة", desc: "التطوير، التجريب، والإنتاج من لوحة واحدة، لكل واحدة قواعد فرع خاصة، دون تجهيز خوادم منفصلة." },
        { title: "نطاقات مخصصة و HTTPS", desc: "وجّهوا نطاقًا، تحققوا منه، واخدموا الزيارات بأمان من اليوم الأول." },
        { title: "أسرار لكل بيئة", desc: "أديروا متغيرات البيئة والأسرار بشكل منفصل، وغيّروا الإعدادات دون إعادة بناء." },
        { title: "نشر تلقائي", desc: "حددوا قواعد الفروع مرة. كل دفعة إلى الفرع الصحيح تنشر إلى البيئة الصحيحة." },
        { title: "سجلات وتراجع بضغطة واحدة", desc: "كل إصدار مُتتبَّع بالسجلات، الحالة، ورابط معاينة. تراجعوا بضغطات قليلة عند الخطأ." },
      ] },
      { type: "grid", heading: "من يُشغّله", items: [
        { title: "للمطوّرين", desc: "أطلقوا الميزات دون انتظار البنية التحتية. انشروا، اقرأوا السجلات، أديروا الإعدادات، وأدعوا الزملاء دون مشاركة صلاحيات الخوادم." },
        { title: "لفرق المنصات", desc: "حيث يوجد فريق عمليات، يحافظ على التحكم بالحوسبة، توجيه الحافة، التوسع، وسجلات التدقيق، دون إبطاء المطورين." },
      ] },
      { type: "bullets", heading: "لمن يناسب", items: [
        "فرق منتجات صغيرة دون مهندس عمليات مخصص",
        "الوكالات التي تُشغّل تطبيقات عملاء عديدة",
        "الشركات التي لا تزال عملية نشرها تعتمد على شخص واحد يعرف الخوادم",
      ] },
    ],
    related: [
      { tag: "الخدمات", label: "الحوسبة السحابية والعمليات التقنية", to: "/ar/services/cloud-devops-oman" },
      { tag: "الخدمات", label: "دعم التطبيقات", to: "/ar/services/application-support-maintenance-oman" },
      { tag: "الصناعات", label: "كل الصناعات", to: "/ar/industries" },
    ],
  },
  "leadaro": {
    slug: "leadaro",
    navLabel: "Leadaro — عملاء محتملون B2B",
    eyebrow: "الحلول",
    h1: "Leadaro — عملاء محتملون وتواصل آلي بالذكاء الاصطناعي",
    meta: { title: "Leadaro — منصة توليد عملاء محتملين B2B | وفا سوليوشنز", description: "بيانات تواصل موثقة، وكلاء ذكاء اصطناعي يكتبون ويوقّتون التواصل، ومسار واحد من أول رسالة إلى صفقة مغلقة." },
    intro: "معظم أدوات التواصل تؤتمت الإرسال فقط وتترك التفكير لكم. يذهب Leadaro أبعد — وكلاء ذكاء اصطناعي يجدون جهات اتصال موثقة، يكتبون الرسالة، يختارون توقيت إرسالها، ويتابعون تلقائيًا، وكل شيء مُتتبَّع في مسار واحد.",
    sections: [
      { type: "callout", text: "الحالة: مباشر · الولايات المتحدة والهند." },
      { type: "grid", heading: "ما يقدّمه", items: [
        { title: "بيانات تواصل موثقة", desc: "وصول لبيانات جهات اتصال وأدوار B2B عبر القطاعات والمناطق، مُحدَّثة لا مُتقادمة في جدول بيانات." },
        { title: "وكلاء تواصل بالذكاء الاصطناعي", desc: "وكلاء يُصيغون، يُخصّصون، يُجدولون، ويُرسلون، لتقرأ كل رسالة كأنها كُتبت لشخص واحد." },
        { title: "توقيت يحدده التفاعل", desc: "الوكلاء يحللون أنماط التفاعل ويرسلون حين يكون الرد أرجح، بدلًا من ساعة ثابتة." },
        { title: "متابعة تلقائية", desc: "التسلسلات تستمر حتى يرد أحدهم، ثم تتوقف. هنا يفشل معظم التواصل بصمت." },
        { title: "التقاط الوافدين وتخصيبهم", desc: "تعرّفوا على الزوار، خصّبوا بياناتهم، قيّموهم، ووجّهوهم بينما لا يزال اهتمامهم قائمًا." },
        { title: "إمكانية التسليم والإحماء", desc: "سمعة الإرسال مُدارة بشكل صحيح، مع تحقق لمنع الارتدادات." },
      ] },
      { type: "bullets", heading: "لمن يناسب", items: [
        "فرق مبيعات تعمل بالإرسال الخارجي يدويًا في جداول بيانات",
        "الوكالات التي تُدير حملات لعملاء متعددين",
        "الشركات التي لا تتحول زيارات موقعها إلى جهة اتصال باسم",
      ] },
    ],
    related: [
      { tag: "الخدمات", label: "الذكاء الاصطناعي والبيانات", to: "/ar/ai-lab" },
      { tag: "الخدمات", label: "تطوير CRM", to: "/ar/services/crm-software-development-company-in-oman" },
      { tag: "الصناعات", label: "كل الصناعات", to: "/ar/industries" },
    ],
  },
};
